export default {
  'menu.crm.nav.performance': '业绩',
  'menu.crm.performance.overview': '业绩概览',
  'menu.crm.performance.targets': '目标管理',
  'menu.crm.performance.entries': '业绩明细',
  'menu.crm.performance.splits': '业绩分摊',
  'menu.crm.performance.team': '团队达成',
  'menu.crm.performance.reconciliation': '核对与锁定',

  'menu.crm.nav.business-trip': '出差',
  'menu.zy-crm.analytics.business': '经营分析',
  'menu.zy-crm.analytics.customer': '客户分析',
  'menu.zy-crm.analytics.sales': '销售分析',
  'menu.zy-crm.analytics.performance': '业绩分析',
  'menu.zy-crm.analytics.product': '产品分析',
  'menu.crm.scope.my': '我负责的',
  'menu.crm.scope.team': '下属负责的',
  'menu.crm.scope.collab': '我协作的',
  'menu.crm.scope.followed': '我关注的',
  'menu.crm.scope.all': '全部',
  'menu.crm.page.overview': '概览',
  'menu.crm.page.approval': '审批',
  'menu.crm.page.calendar': '日历',
  'menu.crm.page.business-trip': '出差助手',
  'menu.crm.page.task': '任务',
  'menu.crm.page.follow-up': '跟进',
  'menu.crm.page.attachment': '附件',
  'menu.crm.page.lead-source': '来源分析',

  'menu.crm.help': '帮助',
  'menu.crm.nav.workbench': '工作台',
  'menu.crm.nav.marketing': '营销',
  'menu.crm.nav.lead': '线索',
  'menu.crm.nav.customer': '客户',
  'menu.crm.nav.contact': '联系人',
  'menu.crm.nav.opportunity': '商机',
  'menu.crm.nav.quote': '报价',
  'menu.crm.nav.product': '产品',
  'menu.crm.nav.contract': '合同',
  'menu.crm.nav.receipt': '回款',
  'menu.crm.nav.analysis': '分析',
  'menu.zy-crm.products.catalog': '产品目录',
  'menu.zy-crm.workbench.overview': '概览',

  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.zy-crm': '组织管理后台',
  'menu.zy-crm.workbench': '工作台',
  'menu.zy-crm.workbench.home': '工作台',
  'menu.zy-crm.workbench.dashboard': '仪表盘',
  'menu.zy-crm.approvals': '审批中心',
  'menu.zy-crm.collaboration': '协同办公',
  'menu.zy-crm.collaboration.calendar': '日历',
  'menu.zy-crm.collaboration.followUps': '跟进记录',
  'menu.zy-crm.collaboration.tasks': '任务中心',
  'menu.zy-crm.collaboration.attachments': '附件中心',
  'menu.zy-crm.leads': '线索',
  'menu.zy-crm.leads.overview': '概览',
  'menu.zy-crm.leads.my': '我负责的线索',
  'menu.zy-crm.leads.team': '下属负责的',
  'menu.zy-crm.leads.collab': '我协作的',
  'menu.zy-crm.leads.pool': '线索池',
  'menu.zy-crm.leads.all': '全部',
  'menu.zy-crm.leads.imported': '留资转入',
  'menu.zy-crm.leads.importConflicts': '导入冲突',
  'menu.zy-crm.customers': '客户',
  'menu.zy-crm.customers.overview': '概览',
  'menu.zy-crm.customers.my': '我负责的客户',
  'menu.zy-crm.customers.team': '下属负责的',
  'menu.zy-crm.customers.collab': '我协作的',
  'menu.zy-crm.customers.pool': '客户池',
  'menu.zy-crm.customers.all': '全部',
  'menu.zy-crm.contacts': '联系人',
  'menu.zy-crm.contacts.overview': '概览',
  'menu.zy-crm.contacts.my': '我负责的联系人',
  'menu.zy-crm.contacts.team': '下属负责的',
  'menu.zy-crm.contacts.collab': '我协作的',
  'menu.zy-crm.contacts.all': '全部',
  'menu.zy-crm.opportunities': '商机',
  'menu.zy-crm.opportunities.overview': '概览',
  'menu.zy-crm.opportunities.my': '我负责的商机',
  'menu.zy-crm.opportunities.followed': '我关注的商机',
  'menu.zy-crm.opportunities.team': '下属负责的',
  'menu.zy-crm.opportunities.collab': '我协作的',
  'menu.zy-crm.opportunities.pool': '商机池',
  'menu.zy-crm.opportunities.all': '全部',
  'menu.zy-crm.quotes': '报价单',
  'menu.zy-crm.quotes.my': '我负责的',
  'menu.zy-crm.quotes.team': '下属负责的',
  'menu.zy-crm.quotes.collab': '我协作的',
  'menu.zy-crm.quotes.all': '全部',
  'menu.zy-crm.quotes.detail': '报价单详情',
  'menu.zy-crm.contracts': '合同',
  'menu.zy-crm.contracts.my': '我负责的',
  'menu.zy-crm.contracts.team': '下属负责的',
  'menu.zy-crm.contracts.collab': '我协作的',
  'menu.zy-crm.contracts.all': '全部',
  'menu.zy-crm.contracts.detail': '合同详情',
  'menu.zy-crm.receipts': '回款',
  'menu.zy-crm.receipts.list': '回款列表',
  'menu.zy-crm.receipts.schedules': '回款计划',
  'menu.zy-crm.receipts.schedules.detail': '回款计划详情',
  'menu.zy-crm.invoices': '发票',
  'menu.zy-crm.invoices.detail': '发票详情',
  'menu.zy-crm.products': '产品',
  'menu.zy-crm.products.detail': '产品详情',
  'menu.zy-crm.marketing': '市场活动',
  'menu.zy-crm.marketing.campaigns': '活动列表',
  'menu.zy-crm.marketing.campaigns.detail': '活动详情',
  'menu.zy-crm.analytics': '数据分析',
  'menu.zy-crm.analytics.leadSource': '线索来源分析',
  'menu.zy-crm.analytics.businessMap': '业务地图',
  'menu.zy-crm.analytics.governance': '数据治理',
  'menu.zy-crm.settings': '系统设置',
  'menu.zy-crm.settings.general': '系统通用',
  'menu.zy-crm.settings.lead': '线索设置',
  'menu.zy-crm.settings.customer': '客户设置',
  'menu.zy-crm.settings.opportunity': '商机设置',
  'menu.zy-crm.settings.product': '产品设置',
  'menu.zy-crm.settings.marketing': '市场活动设置',
  'menu.zy-crm.settings.contract': '合同设置',
  'menu.zy-crm.leadManagement': '线索',
  'menu.zy-crm.leadManagement.lead.my': '我负责的线索',
  'menu.zy-crm.leadManagement.lead.team': '下属负责的',
  'menu.zy-crm.leadManagement.lead.collab': '我协作的',
  'menu.zy-crm.leadManagement.lead.pool': '线索池',
  'menu.zy-crm.leadManagement.lead.all': '全部',
  'menu.zy-crm.customerManagement': '客户',
  'menu.zy-crm.customerManagement.customer.my': '我负责的客户',
  'menu.zy-crm.customerManagement.customer.team': '下属负责的',
  'menu.zy-crm.customerManagement.customer.collab': '我协作的',
  'menu.zy-crm.customerManagement.customer.pool': '客户池',
  'menu.zy-crm.customerManagement.customer.all': '全部',
  'menu.zy-crm.customerManagement.contact': '联系人',
  'menu.zy-crm.customerManagement.contact.my': '我负责的联系人',
  'menu.zy-crm.customerManagement.contact.team': '下属负责的',
  'menu.zy-crm.customerManagement.contact.collab': '我协作的',
  'menu.zy-crm.customerManagement.contact.all': '全部',
  'menu.zy-crm.customerManagement.contact.detail': '联系人详情',
  'menu.zy-crm.salesManagement': '商机',
  'menu.zy-crm.salesManagement.opportunity.my': '我负责的商机',
  'menu.zy-crm.salesManagement.opportunity.followed': '我关注的商机',
  'menu.zy-crm.salesManagement.opportunity.team': '下属负责的',
  'menu.zy-crm.salesManagement.opportunity.collab': '我协作的',
  'menu.zy-crm.salesManagement.opportunity.all': '全部',
  'menu.zy-crm.salesManagement.opportunity.pool': '商机池',
  'menu.zy-crm.salesManagement.quote': '报价单',
  'menu.zy-crm.salesManagement.quote.my': '我负责的',
  'menu.zy-crm.salesManagement.quote.team': '下属负责的',
  'menu.zy-crm.salesManagement.quote.collab': '我协作的',
  'menu.zy-crm.salesManagement.quote.all': '全部',
  'menu.zy-crm.salesManagement.quote.detail': '报价单详情',
  'menu.zy-crm.salesManagement.product': '产品',
  'menu.zy-crm.salesManagement.product.detail': '产品详情',
  'menu.zy-crm.contractAndReceipt': '合同',
  'menu.zy-crm.contractAndReceipt.contract': '合同',
  'menu.zy-crm.contractAndReceipt.contract.detail': '合同详情',
  'menu.zy-crm.contractAndReceipt.receipt': '回款',
  'menu.zy-crm.contractAndReceipt.receipt.detail': '回款详情',
  'menu.zy-crm.contractAndReceipt.receipt-schedule': '回款计划',
  'menu.zy-crm.contractAndReceipt.receipt-schedule.detail': '回款计划详情',
  'menu.zy-crm.contractAndReceipt.invoice': '发票',
  'menu.zy-crm.contractAndReceipt.invoice.detail': '发票详情',
  'menu.zy-crm.contractAndReceipt.invoiceProfile': '发票信息',
  'menu.zy-crm.analytics.leadSourceAnalysis': '线索来源分析',
  'menu.zy-crm.systemConfig': '系统配置',
  'menu.zy-crm.systemConfig.general': '系统通用',
  'menu.zy-crm.systemConfig.lead': '线索设置',
  'menu.zy-crm.systemConfig.customer': '客户设置',
  'menu.zy-crm.systemConfig.opportunity': '商机设置',
  'menu.zy-crm.systemConfig.product': '产品设置',
  'menu.zy-crm.systemConfig.marketing': '市场活动设置',
  'menu.zy-crm.systemConfig.contract': '合同设置',
  'menu.zy-crm.systemConfig.permissions': '权限配置',
  'menu.zy-crm.systemConfig.taxonomies': '标签管理',
  'menu.zy-crm.systemConfig.automationRules': '自动化规则',
  'menu.zy-crm.systemConfig.workflowApproval': '审批配置',
  'menu.zy-crm.systemConfig.invoiceProfile': '发票信息',
  'menu.zy-crm.systemConfig.tavily': 'Tavily 设置',
  'menu.zy-crm.systemConfig.modelSettings': '模型设置',
  'menu.zy-crm.systemConfig.customerPoolConfigs': '客户公海配置',
  'menu.zy-crm.systemConfig.leadPoolConfigs': '线索池配置',
  'menu.zy-crm.systemConfig.leadAssignRules': '线索分配规则',
  'menu.zy-crm.systemConfig.customerLimitConfigs': '私池上限配置',
  'menu.zy-crm.systemConfig.dictionaryManagement': '数据字典',
  'menu.zy-crm.systemConfig.productCategories': '产品分类配置',
  'menu.zy-crm.systemConfig.opportunityPipelines': '商机管道',
  'menu.zy-crm.systemConfig.opportunityStages': '商机阶段',
  'menu.zy-crm.systemConfig.areas': '地区配置',
  'menu.zy-crm.systemConfig.sourceChannels': '来源渠道配置',
  'menu.zy-crm.systemConfig.customerLevels': '客户等级配置',
  'menu.zy-crm.systemConfig.industries': '行业配置',
  'menu.zy-crm.systemConfig.marketingCampaignTypes': '活动类型',
  'menu.zy-crm.systemConfig.marketingTouchpointTypes': '接入点类型',
  'menu.zy-crm.systemConfig.contractConfigs': '合同配置',
  'menu.zy-crm.systemConfig.contractCodeRules': '合同编号规则',
  'menu.zy-crm.systemConfig.productCodeRules': '产品编号规则',
  'menu.zy-crm.dashboard': '仪表盘',
  'menu.zy-crm.calendar': '日历',
  'menu.zy-crm.lead': '线索',
  'menu.zy-crm.lead.my': '我的线索',
  'menu.zy-crm.lead.pool': '线索池',
  'menu.zy-crm.lead.all': '全部线索',
  'menu.zy-crm.customer': '客户',
  'menu.zy-crm.customer.my': '我的客户',
  'menu.zy-crm.customer.pool': '客户池',
  'menu.zy-crm.customer.all': '全部客户',
  'menu.zy-crm.contact': '联系人',
  'menu.zy-crm.contact.detail': '联系人详情',
  'menu.zy-crm.opportunity': '商机',
  'menu.zy-crm.opportunity.my': '我的商机',
  'menu.zy-crm.opportunity.all': '全部商机',
  'menu.zy-crm.opportunity.pool': '商机池',
  'menu.zy-crm.opportunity.detail': '商机详情',
  'menu.zy-crm.quote': '报价单',
  'menu.zy-crm.quote.detail': '报价单详情',
  'menu.zy-crm.product': '产品',
  'menu.zy-crm.product.detail': '产品详情',
  'menu.zy-crm.contract': '合同',
  'menu.zy-crm.contract.detail': '合同详情',
  'menu.zy-crm.receipt': '回款',
  'menu.zy-crm.receipt.detail': '回款详情',
  'menu.zy-crm.receipt-schedule': '回款计划',
  'menu.zy-crm.receipt-schedule.detail': '回款计划详情',
  'menu.zy-crm.invoice': '发票',
  'menu.zy-crm.invoice.detail': '发票详情',
  'menu.zy-crm.invoiceProfile': '发票信息',
  'menu.zy-crm.followUps': '跟进记录',
  'menu.zy-crm.tasks': '任务中心',
  'menu.zy-crm.attachments': '附件中心',
  'menu.zy-crm.governance': '数据治理',
  'menu.zy-crm.automationRules': '自动化规则',
  'menu.zy-crm.permissions': '数据权限',
  'menu.zy-crm.customerLimitConfigs': '私池上限配置',
  'menu.zy-crm.customerPoolConfigs': '客户公海配置',
  'menu.zy-crm.leadPoolConfigs': '线索池配置',
  'menu.zy-crm.leadAssignRules': '线索分配规则',
  'menu.zy-crm.sourceChannels': '来源渠道配置',
  'menu.zy-crm.opportunityPipelines': '商机管道',
  'menu.zy-crm.opportunityStages': '商机阶段',
  'menu.zy-crm.areas': '地区配置',
  'menu.zy-crm.industries': '行业配置',
  'menu.zy-crm.contractConfigs': '合同配置',
  'menu.zy-crm.productCategories': '产品分类配置',
  'menu.zy-crm.contractCodeRules': '合同编号规则',
  'menu.zy-crm.productCodeRules': '产品编号规则',
};
